// extracted by mini-css-extract-plugin
export default {"details":"JobDetails-module__details__XtMom"};